'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);

const touchField = (field) => {
  if (!field) {
    return;
  }
  if (field.$touch) {
    field.$touch();
  }
  if (field.$each && field.$each.$iter) {
    for (const innerField of Array.from(field.$each.$iter)) {
      touchField(innerField);
    }
  }
};
const ValidationGuard = () => Component.createDecorator((options, key) => {
  if (!options.methods) {
    options.methods = {};
  }
  if (!options.validations) {
    return;
  }
  const methodToGuard = options.methods[key];
  if (methodToGuard) {
    options.methods[key] = function(...args) {
      if (this.$v.$invalid) {
        let firstInvalidField = null;
        for (const field of Object.keys(this.$v)) {
          if (field.startsWith("$") || field.startsWith("_")) {
            continue;
          }
          if (this.$v[field].$invalid && firstInvalidField === null) {
            firstInvalidField = this.$refs[field];
          }
          touchField(this.$v[field]);
        }
        return;
      }
      methodToGuard.call(this, ...args);
    };
  }
});

exports.ValidationGuard = ValidationGuard;
exports.touchField = touchField;
